/*
 * @Author: Luz Liu luz.liu@zoom.us
 * @Date: 2022-07-27 11:20:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-29 15:00:35
 * @FilePath: \async-component-ui\packages\directives\omit.js
 * @Description: ~
 */
import Vue from 'vue'
import Tooltip from '@zoom/zoom-ui/src/components/tooltip/index'

const template = Vue.extend(Tooltip)

let maxWidth = 200
const PLACEMENTS = ['top', 'right', 'bottom', 'left']

export default {
  name: 'omit',
  inserted(el, binding) {
    Object.keys(binding.modifiers).forEach((item) => {
      maxWidth = Number.isSafeInteger(Number(item)) ? Number(item) : maxWidth
    })
    const currentWidth = parseInt(window.getComputedStyle(el, null).width)

    if (currentWidth > maxWidth) {
      el.style.setProperty('width', maxWidth + 'px', 'important')
      el.style.setProperty('overflow', 'hidden', 'important')
      el.style.setProperty('text-overflow', 'ellipsis', 'important')
      el.style.setProperty('white-space', 'nowrap', 'important')

      const instance = new template({
        propsData: {
          popperClass: 'as-v-omit',
        },
      }).$mount()
      instance.referenceElm = el
      instance.content = el.innerText
      const placementOpts = Object.keys(binding.modifiers).filter((item) =>
        PLACEMENTS.includes(item)
      )
      placementOpts.length &&
        (instance.currentPlacement = placementOpts[placementOpts.length - 1])
      instance.createPopper()

      el.addEventListener('mouseenter', instance.show)
      el.addEventListener('mouseleave', instance.hide)

      if (!el.hasAttribute('tabIndex')) {
        el.setAttribute('tabIndex', 0)
      }
    }
  },
}
